<template>
    <el-dialog class="tw-query-dialog" :title="`查询 - ${condition.caption}`" v-model="dialogVisible" width="500px" @close="onCancel" center>
        <el-form :model="condition" ref="refForm" label-width="100px">
            <el-form-item v-for="(param, index) in condition.params" :key="param.name" 
                :label="param.caption" :prop="'params.' + index + '.value'" 
                :rules="{ required: true, message: `请输入${param.caption}`, trigger: 'blur' }">
                <el-input v-model="param.value"></el-input>
            </el-form-item>
            <el-form-item v-for="query in condition.query" :key="query.name" :label="query.caption" :prop="query.name">
                <!-- <el-input v-model="query.value"></el-input> -->
                <component :is="getComponentName(query.data_type)" :key="query.name" v-model="query.value">
                </component>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="onCancel">取 消</el-button>
            <el-button style="margin-left:10px" type="primary" @click="onConfig">确 定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
// import httpService from '../../services/http.service'
// import systemService from '../../services/system.service'

export default {
    name: 'tw-query-dialog',
    props: {
        params: {
            type: Object
        },
        resolve: {
            type: Function,
            required: true
        },
        reject: {
            type: Function,
            required: true
        }
    },
    setup(props) {
        const refForm = ref(null)
        const dialogVisible = ref(true)
        const condition = reactive({
            // query: [ 
            //     { name: "SolidFlag", caption: "测试", value: "0" }, 
            //     { name: "BeginDate", caption: "开始日期", value: "2021-06-01" }, 
            //     { name: "EndDate", caption: "结束日期", value: "2021-06-30" }
            // ],
            // params: [ 
            //     { name: "sobno", caption: "账套号", value: "0003" }
            // ]
        })

        // 改为从props中获取
        // httpService.get('data-condition', { project_id: systemService.project_id, name: props.params.name }).then(data => {
        //     condition.caption = data.caption
        //     condition.query = data.query
        //     condition.params = data.params
        // })
        const initCondition = function(params) {
            condition.caption = params.caption
            condition.query = params.query
            condition.params = params.params
        }
        initCondition(props.params)
        
        const getComponentName = function(dataType) {
            let componentName
            switch (dataType) {
                case 'Date':
                case 'DateTime': {
                    componentName = 'el-date-picker'
                    break;
                }
                case 'Double':
                case 'Int32': {
                    componentName = 'el-input-number'
                    break;
                }
                case 'Boolean': {
                    componentName = 'el-switch'
                    break;
                }
                default: {
                    // String、Object
                    componentName = 'el-input'
                    break;
                }
            }

            return componentName
        }

        const onConfig = function() {
            refForm.value.validate((valid) => {
                if (valid) {
                    const query = {}
                    const params = {}
                    condition.query?.forEach(el => {
                        if (el.value) {
                            query[el.name] = el.value
                        }
                    })
                    condition.params?.forEach(el => {
                        if (el.value) {
                            params[el.name] = el.value
                        }
                    })
                    const result = {}
                    if (JSON.stringify(query) != '{}') {
                        result.query = query
                    }
                    if (JSON.stringify(params) != '{}') {
                        result.params = params
                    }
                    props.resolve(result)
                    dialogVisible.value = false
                }
            })
        }

        const onCancel = function() {
            props.reject()
        }

        const onKeyDown = function(e) {
            if (e.code === 'Enter') {
                onConfig()
            }
        }

        onMounted(() => {
            document.addEventListener('keydown', onKeyDown, true)
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown, true)
        })

        return {
            refForm,
            dialogVisible,
            condition,
            getComponentName,
            onConfig,
            onCancel
        }
    }
}
</script>

<style>
@media screen and (max-width: 775px) {
    .el-dialog {
        width: calc(100% - 10px * 2) !important;
        height: calc(100vh - 10px * 2) !important;
        margin: 10px !important;
    }
}
</style>